import { render, staticRenderFns } from "./ListBrand.vue?vue&type=template&id=619d1ad6&scoped=true"
import script from "./ListBrand.vue?vue&type=script&lang=js"
export * from "./ListBrand.vue?vue&type=script&lang=js"
import style0 from "./ListBrand.vue?vue&type=style&index=0&id=619d1ad6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619d1ad6",
  null
  
)

export default component.exports